import React, { FC } from 'react'

import { Box } from '@mui/material'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { useRegisterPageImages } from '../../hooks/useRegisterPageImages'
import HeaderCloseableFlow from './header-closeable-flow'

const RegisterHeader: FC<{ onClose: () => void }> = ({ onClose }) => {
  const { image, renderedHeight, renderedWidth, headerTransform, maxImageWidths } =
    useRegisterPageImages()

  return (
    <HeaderCloseableFlow onClose={onClose}>
      <Box
        position="absolute"
        sx={{
          top: '0',
          left: '50%',
          width: renderedWidth,
          height: renderedHeight,
          transform: `${headerTransform}`,
          maxWidth: maxImageWidths
        }}
      >
        <GatsbyImage image={getImage(image)} alt={'Customized Action Cards'} />
      </Box>
    </HeaderCloseableFlow>
  )
}

export default RegisterHeader
